export const APP_NAME = '轻息AI'

// 七鱼客服APP ID
export const YSF_APP_ID = '59898739da2e0975c49dfdfe668af29a'
